<template>
  <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
    <template v-if="loading">
      <div v-for="i in 2" :key="i" class="bg-white rounded-xl border border-gray-200 p-5 animate-pulse">
        <div class="h-4 bg-gray-200 rounded w-24 mb-4"></div>
        <div class="h-8 bg-gray-200 rounded w-32 mb-3"></div>
        <div class="h-5 bg-gray-200 rounded w-20"></div>
      </div>
    </template>
    <div v-else-if="error" class="col-span-full bg-red-50 border border-red-200 rounded-xl p-4 flex items-center justify-between">
      <span class="text-sm text-red-600">{{ error }}</span>
      <button @click="refresh" class="text-sm text-red-700 font-medium hover:underline">Reessayer</button>
    </div>
    <template v-else-if="data">
      <KpiCard
        v-for="kpi in kpis"
        :key="kpi.key"
        :label="kpi.label"
        :value="kpi.value"
        :evolution="kpi.evolution"
        :format="kpi.format"
        :icon="kpi.icon"
      />
    </template>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { useDashboard } from '@/composables/useDashboard'
import { useDateRange } from '@/composables/useDateRange'
import KpiCard from './KpiCard.vue'

const { dateParams } = useDateRange()
const { data, loading, error, refresh } = useDashboard('/dashboard/kpi/revenue', dateParams)

const kpis = computed(() => {
  if (!data.value) return []
  const d = data.value
  return [
    { key: 'revenue', label: "Chiffre d'affaires", value: d.revenue?.current, evolution: d.revenue?.evolution, format: 'currency', icon: 'chart-line' },
    { key: 'revenue_per_day', label: 'CA / jour', value: d.revenue_per_day?.current, evolution: d.revenue_per_day?.evolution, format: 'currency', icon: 'calendar' }
  ]
})
</script>
